// actionTypes.js
export const FETCH_EMPLOYEES_REQUEST = 'FETCH_EMPLOYEES_REQUEST';
export const FETCH_EMPLOYEES_SUCCESS = 'FETCH_EMPLOYEES_SUCCESS';
export const FETCH_EMPLOYEES_FAILURE = 'FETCH_EMPLOYEES_FAILURE';

export const CREATE_EMPLOYEE_REQUEST = 'CREATE_EMPLOYEE_REQUEST';
export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS';
export const CREATE_EMPLOYEE_FAILURE = 'CREATE_EMPLOYEE_FAILURE';

export const EMPLOYEE_DROPDOWN_REQUEST = "EMPLOYEE_DROPDOWN_REQUEST";
export const EMPLOYEE_DROPDOWN_SUCCESS = "EMPLOYEE_DROPDOWN_SUCCESS";
export const EMPLOYEE_DROPDOWN_FAILURE = "EMPLOYEE_DROPDOWN_FAILURE";

export const EMPLOYEE_DROPDOWN_AUTO_LIST_REQUEST = "EMPLOYEE_DROPDOWN_AUTO_LIST_REQUEST";
export const EMPLOYEE_DROPDOWN_AUTO_LIST_SUCCESS = "EMPLOYEE_DROPDOWN_AUTO_LIST_SUCCESS";
export const EMPLOYEE_DROPDOWN_AUTO_LIST_FAILURE = "EMPLOYEE_DROPDOWN_AUTO_LIST_FAILURE";

export const FETCH_EMPLOYEE_TAB_WISE_INFO = "FETCH_EMPLOYEE_TAB_WISE_INFO";
export const FETCH_EMPLOYEE_TAB_WISE_INFO_SUCCESS = "FETCH_EMPLOYEE_TAB_WISE_INFO_SUCCESS";
export const FETCH_EMPLOYEE_TAB_WISE_INFO_FAILURE = "FETCH_EMPLOYEE_TAB_WISE_INFO_FAILURE";

export const DELETE_DOCUMENT_REQUEST = "DELETE_DOCUMENT_REQUEST";
export const DELETE_DOCUMENT_SUCCESS = "DELETE_DOCUMENT_SUCCESS";
export const DELETE_DOCUMENT_FAILURE = "DELETE_DOCUMENT_FAILURE";

export const FETCH_ACTIVE_EMPLOYEES_REQUEST = 'FETCH_ACTIVE_EMPLOYEES_REQUEST';
export const FETCH_ACTIVE_EMPLOYEES_SUCCESS = 'FETCH_ACTIVE_EMPLOYEES_SUCCESS';
export const FETCH_ACTIVE_EMPLOYEES_FAILURE = 'FETCH_ACTIVE_EMPLOYEES_FAILURE';

export const FETCH_EMPLOYEE_VIEW_PROFILE_REQUEST = 'FETCH_EMPLOYEE_VIEW_PROFILE_REQUEST';
export const FETCH_EMPLOYEE_VIEW_PROFILE_SUCCESS = 'FETCH_EMPLOYEE_VIEW_PROFILE_SUCCESS';
export const FETCH_EMPLOYEE_VIEW_PROFILE_FAILURE = 'FETCH_EMPLOYEE_VIEW_PROFILE_FAILURE';

//Dinesh Starting--------------------------------------------------------------------------------- //
export const FETCH_TRANSFER_TYPES = 'FETCH_TRANSFER_TYPES';
export const FETCH_TRANSFER_TYPES_SUCCESS = 'FETCH_TRANSFER_TYPES_SUCCESS';
export const FETCH_TRANSFER_TYPES_FAILURE = 'FETCH_TRANSFER_TYPES_FAILURE';

export const FETCH_FROM_CATEGORY = 'FETCH_FROM_CATEGORY';
export const FETCH_FROM_CATEGORY_SUCCESS = 'FETCH_FROM_CATEGORY_SUCCESS';
export const FETCH_FROM_CATEGORY_FAILURE = 'FETCH_FROM_CATEGORY_FAILURE';

export const FETCH_FROM_DESIGNATION = 'FETCH_FROM_DESIGNATION';
export const FETCH_FROM_DESIGNATION_SUCCESS = 'FETCH_FROM_DESIGNATION_SUCCESS';
export const FETCH_FROM_DESIGNATION_FAILURE = 'FETCH_FROM_DESIGNATION_FAILURE';

export const FETCH_FROM_DEPARTMENT = 'FETCH_FROM_DEPARTMENT';
export const FETCH_FROM_DEPARTMENT_SUCCESS = 'FETCH_FROM_DEPARTMENT_SUCCESS';
export const FETCH_FROM_DEPARTMENT_FAILURE = 'FETCH_FROM_DEPARTMENT_FAILURE';

export const FETCH_REPORTING = 'FETCH_REPORTING';
export const FETCH_REPORTING_SUCCESS = 'FETCH_REPORTING_SUCCESS';
export const FETCH_REPORTING_FAILURE = 'FETCH_REPORTING_FAILURE';

export const FETCH_EMPLOYEELISTTOTRANSFER = 'FETCH_EMPLOYEELISTTOTRANSFER';
export const FETCH_EMPLOYEELISTTOTRANSFER_SUCCESS = 'FETCH_EMPLOYEELISTTOTRANSFER_SUCCESS';
export const FETCH_EMPLOYEELISTTOTRANSFER_FAILURE = 'FETCH_EMPLOYEELISTTOTRANSFER_FAILURE';

export const SAVE_TRANSFER_REQUEST = 'SAVE_TRANSFER_REQUEST';
export const SAVE_TRANSFER_SUCCESS = 'SAVE_TRANSFER_SUCCESS';
export const SAVE_TRANSFER_FAILURE = 'SAVE_TRANSFER_FAILURE';
export const CLEAR_EMPLOYEE_LIST = "CLEAR_EMPLOYEE_LIST";

export const FETCH_TRANSFERLOGS = 'FETCH_TRANSFERLOGS';
export const FETCH_TRANSFERLOGS_SUCCESS = 'FETCH_TRANSFERLOGS_SUCCESS';
export const FETCH_TRANSFERLOGS_FAILURE = 'FETCH_TRANSFERLOGS_FAILURE';

export const GET_SHIFT_GROUP_DETAILS = "GET_SHIFT_GROUP_DETAILS";
export const GET_SHIFT_GROUP_DETAILS_SUCCESS = "GET_SHIFT_GROUP_DETAILS_SUCCESS";
export const GET_SHIFT_GROUP_DETAILS_FAILURE = "GET_SHIFT_GROUP_DETAILS_FAILURE";

export const EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_REQUEST = "EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_REQUEST";
export const EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_SUCCESS = "EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_SUCCESS";
export const EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_FAILURE = "EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_FAILURE";

export const FETCH_NEXT_EMP_NO_REQUEST = 'FETCH_NEXT_EMP_NO_REQUEST';
export const FETCH_NEXT_EMP_NO_SUCCESS = 'FETCH_NEXT_EMP_NO_SUCCESS';
export const FETCH_NEXT_EMP_NO_FAILURE = 'FETCH_NEXT_EMP_NO_FAILURE';

export const EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_REQUEST = "EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_REQUEST";
export const EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_SUCCESS = "EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_SUCCESS";
export const EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_FAILURE = "EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_FAILURE";